import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

export function StatementConfigSidebar({
  statementType,
  onStatementTypeChange,
  transactionCount,
  onTransactionCountChange,
  dateRange,
  onDateRangeChange,
  latestInvoiceNo,
  onSend,
  isSending,
  canSend
}) {
  return (
    <div className="w-64 flex-shrink-0 border-r p-4 space-y-6 overflow-y-auto">
      <div>
        <h3 className="text-sm font-semibold mb-3">Statement Type</h3>
        <RadioGroup
          value={statementType}
          onValueChange={onStatementTypeChange}
          className="space-y-2"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="since_zero" id="cfg-since-zero" />
            <Label htmlFor="cfg-since-zero" className="text-sm">Since zero balance</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="transactions" id="cfg-transactions" />
            <Label htmlFor="cfg-transactions" className="text-sm">Last N transactions</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="period" id="cfg-period" />
            <Label htmlFor="cfg-period" className="text-sm">Date range</Label>
          </div>
        </RadioGroup>
      </div>

      {statementType === 'transactions' && (
        <div>
          <Label htmlFor="tx-count" className="text-sm">Number of transactions</Label>
          <Input
            id="tx-count"
            type="number"
            min={1}
            max={100}
            value={transactionCount}
            onChange={(e) => onTransactionCountChange(parseInt(e.target.value) || 10)}
            className="mt-1"
          />
        </div>
      )}

      {statementType === 'period' && (
        <div className="space-y-2">
          <div>
            <Label htmlFor="start-date" className="text-sm">Start date</Label>
            <Input
              id="start-date"
              type="date"
              value={dateRange.start}
              onChange={(e) => onDateRangeChange({ ...dateRange, start: e.target.value })}
              className="mt-1"
            />
          </div>
          <div>
            <Label htmlFor="end-date" className="text-sm">End date</Label>
            <Input
              id="end-date"
              type="date"
              value={dateRange.end}
              onChange={(e) => onDateRangeChange({ ...dateRange, end: e.target.value })}
              className="mt-1"
            />
          </div>
        </div>
      )}

      <div className="border-t pt-4">
        <p className="text-xs text-muted-foreground mb-2">
          {latestInvoiceNo
            ? `Attaches to invoice: ${latestInvoiceNo}`
            : 'No authorised invoice available'
          }
        </p>
        <Button
          onClick={onSend}
          disabled={isSending || !canSend}
          className="w-full"
        >
          {isSending ? 'Sending...' : 'Send Statement'}
        </Button>
      </div>
    </div>
  )
}
